import { SelectedDateRange } from 'types/misc';
import { AspectScores } from 'types/blockwiseScores';

export const findSelectedCycleAspectScores = (
  allAspectScores: AspectScores[],
  selectedDateRange: SelectedDateRange,
): AspectScores => {
  const selectedCycleAspectScores = allAspectScores.find(
    (aspectScores) =>
      aspectScores.start_date === selectedDateRange.startDate && aspectScores.end_date === selectedDateRange.endDate,
  );
  if (!selectedCycleAspectScores) {
    throw new Error(
      `Could not find aspect scores for the Selected Cycle ${selectedDateRange.startDate} - ${selectedDateRange.endDate} .`,
    );
  }
  return selectedCycleAspectScores;
};

export interface AspectScoreWithDateRange {
  startDate: string;
  endDate: string;
  overallAspectScore: number;
}

/**
 * Returns all AspectScore instances for the given Aspect ID, with their corresponding date ranges.
 */
export const reduceAllAspectScoresByCurrentAspectScore = (
  currentAspectScoreId: number,
  allCycleAspectScores: AspectScores[],
): AspectScoreWithDateRange[] => {
  const currentAspectScoresByDateRange = allCycleAspectScores.reduce<AspectScoreWithDateRange[]>(
    (aspectScoresByDateRange, cycleAspectScores) => {
      const currentAspectScore = cycleAspectScores.aspect_scores.find(
        (aspectScore) => aspectScore.aspect_id === currentAspectScoreId,
      );
      if (currentAspectScore) {
        const aspectScoreWithDateRange: AspectScoreWithDateRange = {
          startDate: cycleAspectScores.start_date,
          endDate: cycleAspectScores.end_date,
          overallAspectScore: currentAspectScore.overall.score,
        };
        return [...aspectScoresByDateRange, aspectScoreWithDateRange];
      }
      return aspectScoresByDateRange;
    },
    [],
  );
  // It is expected that the dates are sorted from newest to oldest,
  // so we reverse the array to get the oldest date first.
  return currentAspectScoresByDateRange.reverse();
};
